import { Component, Input, OnInit } from '@angular/core'
import { ServiceControlPolicyPermissionIssue } from 'src/app/account/services/issue'
import { UiService } from 'src/app/services/ui.service'
import { ViewableIssue } from '../../issues-view/issues-view.component'
import { AccountService } from '../../../services/account.service'

@Component({
  selector: 'service-control-policy-permission-issue',
  templateUrl: './service-control-policy-permission-issue.component.html',
  styleUrls: ['./service-control-policy-permission-issue.component.scss'],
  standalone: false,
})
export class ServiceControlPolicyPermissionIssueComponent implements OnInit {
  @Input() issue: ServiceControlPolicyPermissionIssue = null
  @Input() viewableIssue: ViewableIssue = null

  constructor(
    public uiService: UiService,
    public accountService: AccountService
  ) {}

  ngOnInit() {}

  get accountSupportUrl() {
    return this.uiService.buildAccountSupportUrl(this.accountService.accountId)
  }

  get accountResourceTagsUrl() {
    return this.uiService.buildAccountResourceTagsUrl(this.accountService.accountId)
  }
}
